import request from '@/utils/request'; // 获取房间/车库相关信息

export function fetchPropertyList(data) {
  return request({
    url: '/pmsservice/api/chargeResource/insertList',
    method: 'post',
    data: data
  });
} // 获取房间/车库绑定信息

export function fetchBindList(data) {
  return request({
    url: '/pmsservice/api/chargeResource/get',
    method: 'post',
    data: data
  });
} // 汇总

export function fetchTotalList(data) {
  return request({
    url: '/pmsservice/api/chargeResource/list',
    method: 'post',
    data: data
  });
} // 汇总明细

export function fetchDetailList(data) {
  return request({
    url: '/pmsservice/api/chargeResource/detailList',
    method: 'post',
    data: data
  });
}
export function fetchDelete(data) {
  return request({
    url: '/pmsservice/api/chargeResource/delete',
    method: 'post',
    data: data
  });
}
export function fetchSimpleDelete(ids) {
  var data = {
    ids: ids
  };
  return request({
    url: '/pmsservice/api/chargeResource/simpleDelete',
    method: 'post',
    data: data
  });
}
export function getDetail(data) {
  return request({
    url: '/pmsservice/api/chargeStandard/get',
    method: 'post',
    data: data
  });
}
export function insert(data) {
  return request({
    url: '/pmsservice/api/chargeResource/insertBatch',
    method: 'post',
    data: data
  });
} // 批量修改

export function fetchUpdate(data) {
  return request({
    url: '/pmsservice/api/chargeResource/update',
    method: 'post',
    data: data
  });
}